import React, { useEffect, useMemo, useState } from 'react';
import GlobalWrapper from '../../../components/Wrapper/GlobalWrapper';
import { Box, Paper } from '@mui/material';
import GlobalTable from '../../../components/CustomTableWithPagination/GlobalTable';
import { LsqHeaders } from './LsqHeaders';
import { getLsqProspects } from '../../../redux/features/globalSlice';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';

const LsqLeads = () => {
  const { data, meta, loading } = useSelector((state) => state.global.lsqTable);
  const [tableState, setTableState] = useState({
    page: 1,
    pageSize: 50,
    search: '',
    checkedRowIds: [],
    frozenColumns: [],
    hiddenColumns: [],
  });
  const dispatch = useDispatch();
  const dispatchParams = useMemo(
    () => ({
      page: tableState.page,
      limit: tableState.pageSize,
      search: tableState.search || '',
    }),
    [tableState.page, tableState.pageSize, tableState.search],
  );
  useEffect(() => {
    dispatch(getLsqProspects(dispatchParams));
  }, [dispatch, dispatchParams]);
  return (
    <GlobalWrapper title={'LSQ Leads'}>
      <Paper elevation={3}>
        <Box>
          <GlobalTable
            rowUniqueId="prospect_lead_id"
            headers={LsqHeaders()}
            tableState={tableState}
            setTableState={setTableState}
            loading={loading}
            rows={data}
            meta={meta}
          />
        </Box>
      </Paper>
    </GlobalWrapper>
  );
};

export default LsqLeads;
